// @flow
import React, {useReducer} from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';
import Group from 'sail/Group';
import {UnstyledLink} from 'sail/UnstyledLink';
import {Text} from 'sail/Text';
import Icon from 'sail/Icon';
import type {IconType} from 'sail/Icon';
import {
  useFile,
  CopyReducer,
  COPY_STATUS,
  copyText,
} from 'docs/data/integration-builder';
import type {CopyEvent} from 'docs/data/integration-builder';
import {getFileText} from 'docs/util';

import './CopyButton.scss';

const messages = defineMessages({
  copy: {
    id: 'docsApp.integrationBuilder.terminal.copy',
    description: 'Copy label',
    defaultMessage: 'Copy',
  },
  copied: {
    id: 'docsApp.integrationBuilder.terminal.copied',
    description: 'Label to confirm item has been copied',
    defaultMessage: 'Copied',
  },
  unable: {
    id: 'docsApp.integrationBuilder.terminal.unable',
    description: 'Label for unable to perform copy action',
    defaultMessage: 'Unable to copy',
  },
});

export const getLabelAndIcon = (
  status: CopyEvent,
): {label: any, icon: IconType} => {
  let icon = 'clipboard';
  let label = <FormattedMessage {...messages.copy} />;
  if (status === COPY_STATUS.COMPLETE) {
    icon = 'check';
    label = <FormattedMessage {...messages.copied} />;
  } else if (status === COPY_STATUS.ERROR) {
    icon = 'cross';
    label = <FormattedMessage {...messages.unable} />;
  }
  return {icon, label};
};

export const CopyButton = () => {
  const [status, dispatch] = useReducer(CopyReducer, 'start');
  const copy = copyText(dispatch);
  const {activeFile, contentRefs} = useFile();
  const fileRef = contentRefs[activeFile];
  const {icon, label} = getLabelAndIcon(status);

  return (
    <UnstyledLink
      className="CopyButton"
      onClick={() => {
        const text = getFileText(fileRef);
        copy(text);
      }}
    >
      <Group alignItems="center" direction="horizontal" spacing={8}>
        <Icon icon={icon} size={12} color="gray800" />
        <Text color="gray800" weight="medium" lineHeight={20} size={14}>
          {label}
        </Text>
      </Group>
    </UnstyledLink>
  );
};
